'use client';

import { usePrint } from '@/lib/hooks';
import { UsefulLink } from '@/lib/types';
import { Breadcrumb, LinkBox, Section } from '@/ui';
import { Content } from '@/widgets';
import { Container } from '@mantine/core';
import { useTranslations } from 'next-intl';
import useSWR from 'swr';

const STATIC_MENU_ID = 411;

export default function Usefullinks() {
  const t = useTranslations();
  const { ref, handlePrint } = usePrint();

  const { data, isLoading } = useSWR<UsefulLink[]>(['/authorities/main/get-useful-links']);

  const title = t('Foydali havolalar');
  const secondaryTitle = t('Barcha havolalar');

  const breadcrumbItems = [
    { title: secondaryTitle, isCurrent: true },
    { title, isCurrent: true },
  ];

  return (
    <Container>
      <Section rightMenu={{ isActive: true, id: STATIC_MENU_ID, activeItem: { title } }}>
        <Content ref={ref}>
          <Content.Header details={{ handlePrint }}>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{title}</Content.Title>
          <Content.Body isShareable className="flex flex-col gap-5">
            {isLoading ? (
              <LinkBox.Loading count={6} withImg />
            ) : data && data?.length > 0 ? (
              data?.map((item) => (
                <LinkBox key={item?.id} url={item?.url} target={item?.target} img={item?.icon}>
                  {item?.title}
                </LinkBox>
              ))
            ) : null}
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
